import { Box } from '@chakra-ui/react';
import { SharedFooter } from 'ui-components';

export const LayoutSharedMyAgency: React.FC<{
  children: React.ReactNode;
}> = ({ children, ...props }) => {
  return (
    <Box backgroundColor="primary.0" overflowX="hidden" {...props}>
      <Box
        marginX="auto"
        maxWidth={1296}
        paddingX={['0', '2', '4', '4', '0']}
        paddingY={{ base: 5, sm: 8 }}
        width="100%"
      >
        {children}
      </Box>
      <SharedFooter />
    </Box>
  );
};
